import Enumerable from "linq";

class ProductMode {

    FilterControls(webKeysVisible, controlsForFiltering) {
        return this.FilterControlsParamsObject({
            webKeysVisible: webKeysVisible,
            controlsForFiltering: controlsForFiltering
        });
    }

    FilterControlsParamsObject(paramsObject) {
        var webKeysVisible = paramsObject.webKeysVisible;
        var webKeysVisibleEnumerable = Enumerable.from(webKeysVisible);
        var webKeysNotVisible = paramsObject.webKeysNotVisible;
        var webKeysNotVisibleEnumerable = Enumerable.from(webKeysNotVisible);
        var controlsForFiltering = paramsObject.controlsForFiltering;
        var funcTransformSelect = paramsObject.funcTransformSelect;
        var funcSelectControlKey = paramsObject.funcSelectControlKey;
        return (
            Enumerable
                .from(controlsForFiltering)
                .where(control => {
                    if (control == null)
                        return false;

                    var webControlKeyName = funcSelectControlKey ? funcSelectControlKey(control) : control?.key;
                    var isVisible =
                        webControlKeyName == null
                        ||
                        (
                            (webKeysVisible == null || webKeysVisibleEnumerable.any(it => it.toLowerCase() == webControlKeyName.toLowerCase()))
                            &&
                            (webKeysNotVisible == null || webKeysNotVisibleEnumerable.any(it => it.toLowerCase() == webControlKeyName.toLowerCase()) == false)
                        );
                    return isVisible;
                })
                .select(control => {
                    var webControlKeyName = funcSelectControlKey ? funcSelectControlKey(control) : control?.key;
                    return funcTransformSelect ? funcTransformSelect(control, webControlKeyName) : control;
                })
                .toArray()
        );
    }

}

export default new ProductMode;